import React, { createContext, useContext, useState } from "react";
import { translations } from "@/i18n";

const LangContext = createContext({ lang: "ro", setLang: () => {}, t: translations.ro });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("ro");
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
